import mixpanel from "mixpanel-browser";
import _ from 'lodash';
import { getAppEventName, getAppName } from './validators';
import { getSectors, getCountryName } from './info';
import { createdApi } from '../services/api';

const api = createdApi(process.env.REACT_APP_URL_API_ENGAGEMENT);

const mixpanelTokenNew =  process.env.REACT_APP_MIXPANEL_TOKEN_NEW;

export const mixpanelInitialize = () => {
  try {
    mixpanel.init(mixpanelTokenNew, { debug: true }, 'new');
  } catch (err) {
    console.log(err);
  }
};

const getOS = () => {
  const userAgent = navigator.userAgent;
  if (/Windows NT/.test(userAgent)) {
    return "windows";
  } else if (/Mac OS X|Macintosh/.test(userAgent)) {
    return "ios";
  } else if (/Android/.test(userAgent)) {
    return "android";
  } else if (/Linux/.test(userAgent)) {
    return "linux";
  } else if (/iPhone|iPad/.test(userAgent)) {
    return "ios";
  } else if (/CrOS/.test(userAgent)) {
    return "chrome";
  }
  return "Sistema operacional desconhecido";
};

// chamada api para armazenar os eventos
const apiCallEvents = (page = '', user = {}, business = {}) => {
  try {
    api.post('/panel_event/',{
      message: page, business_id: business?.id || '', user_id: user?.id || '',
    });
  } catch (err) {
    console.log(err);
  }
};

const eventProperties = {
  "Qual_Aplicacao": getAppEventName(),
}

// projeto velho e novo setar props do user e no registro de eventos
export const identifyUser = (business = {}, user = {}, event = '', professionals = []) => {
  if (!_.isEmpty(user)) {
    try {
      mixpanel.new.reset();
      mixpanel.new.identify(`u-${user?.id || ''}`);
      const isOwner = !!(business?.ownerId === user.id);
      const isProfessional = !!(professionals.find(i => i.phone === user.phone));
      const categoriaNames = business?.categories?.map(c => c.name)?.join(', ') || '';
      const setor = getSectors[business?.sectorId] || '';
      const pais = getCountryName({ phone: business?.phone || user?.phone || '' });
      const cadastrouEmpresa = _.isEmpty(business?.sectorId) ? 'Nao' : 'Sim';

      mixpanel.new.people.set({
        "$name": user?.name || 'Sem nome',
        "$email": user?.email || 'Sem email',
        "$phone": user?.phone || user?.phoneUnverified || 'Sem telefone',
        "Owner": isOwner,
        "Professional": isProfessional,
        "Business_Id": business?.id || '',
        "company_id": business?.id || '',
        "Nome_Da_Empresa": business?.name || '',
        "Categoria": categoriaNames,
        "Setor": setor,
        "Pais": pais,
        "Idioma": business?.language || '',
        "Ultimo_Acesso": new Date().toString(),
        "Cadastrou_Empresa": cadastrouEmpresa,
        "Qual_E_O_App": getAppName(),
        "Qual_Aplicacao": getAppEventName(),
      });
      mixpanel.new.register({
        "Name": user?.name || 'Sem nome',
        "Email": user?.email || 'Sem email',
        "Phone": user?.phone || user?.phoneUnverified || 'Sem telefone',
        "Owner": isOwner,
        "Professional": isProfessional,
        "Business_Id": business?.id || '',
        "company_id": business?.id || '',
        "Nome_Da_Empresa": business?.name || '',
        "Categoria": categoriaNames,
        "Setor": setor,
        "Pais": pais,
        "Idioma": business?.language || '',
        "Ultimo_Acesso": new Date().toString(),
        "Cadastrou_Empresa": cadastrouEmpresa,
        "Qual_E_O_App": getAppName(),
        "Qual_Aplicacao": getAppEventName(),
      });
      if (!_.isEmpty(event)) {
        mixpanel.new.track_with_groups(`${event} - ${getAppEventName()}`, {}, {...eventProperties, ...{
          "company_id": business?.id,
        }});
        apiCallEvents(`${event} - ${getAppEventName()}`, user, business);
      }
    } catch (err) {
      console.log(err);
    }
  }
};

export const mixpanelTrackEvent = (event = '', sendUser = {}, sendBusiness = {}, sendApi = false, eventProps = {}) => {
  return new Promise((resolve) => {
    try {
      const shouldTrackUser = !_.isEmpty(sendUser) && !!sendUser?.id;
      const shouldTrackBusiness = !_.isEmpty(sendBusiness) && !!sendBusiness?.id;

      const eventPropertiesGroups = {
        ...eventProperties,
        "Qual_Aplicacao": getAppEventName(),
      }

      const callback = () => resolve();

      if (shouldTrackUser && shouldTrackBusiness)  {
        mixpanel.new.identify(`u-${sendUser?.id}`);
        mixpanel.new.add_group({"company_id": sendBusiness?.id});
        mixpanel.new.track_with_groups(event, eventProps, eventPropertiesGroups, callback);
      } else if (shouldTrackUser) {
        mixpanel.new.identify(`u-${sendUser?.id}`);
        mixpanel.new.track_with_groups(event, eventProps, eventPropertiesGroups, callback);
      } else if (shouldTrackBusiness) {
        mixpanel.new.identify(`${sendBusiness?.id}`);
        mixpanel.new.track_with_groups(event, eventProps, eventPropertiesGroups, callback);
      } else {
        mixpanel.new.track_with_groups(event, eventProps, eventPropertiesGroups, callback);
      }

      // projeto novo chamada nossa api
      if (sendApi) {
        apiCallEvents(`${event} - ${getAppEventName()}`, sendUser || {}, sendBusiness || {});
      }
    } catch (err) {
      console.log(err);
      resolve();
    }
  });
};